"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Message_1 = require("../components/Message");
var Padder_1 = require("../components/Padder");
var Popup_1 = __importDefault(require("../components/Popup/Popup"));
var hooks_1 = require("../hooks");
var RosStatusPopup = function () {
    var status = sessionStorage.getItem('rosStatus');
    var message = sessionStorage.getItem('rosMessage');
    var open = hooks_1.useBoolean(!!status && !!message);
    react_1.useEffect(function () {
        sessionStorage.removeItem('rosStatus');
        sessionStorage.removeItem('rosMessage');
        var timer = setTimeout(function () {
            open.setFalse();
        }, 3000);
        return function () { return clearTimeout(timer); };
    }, []);
    return (react_1.default.createElement(Popup_1.default, { open: open.value, onClose: function () { return open.setFalse(); } },
        react_1.default.createElement(Padder_1.Padder, null,
            react_1.default.createElement(Message_1.Message, { type: status === 'error' || status === 'success' ? status : undefined }, message))));
};
exports.default = RosStatusPopup;
